import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import SignUp from "./components/SignUp";
import Login from "./components/Login";
import Chat from "./components/Chat";
import Settings from "./components/Settings";

import MaintenancePage from "./components/MaintenancePage";
import RecommendedNumbers from "./components/RecommendedNumbers";
import CoinHistory from "./components/CoinHistory";
import Dashboard from "./components/Dashboard";
import WeeklyStatistics from "./components/WeeklyStatistics.js";
import EditProfile from "./components/EditProfile";
import Monitor from "./components/Monitor";
import Subscribe from "./components/Subscribe";
import HistorialChat from "./components/historialchat";
import ConnectedUsers from "./components/ConnectedUsers";
import InvestPage from "./components/InvestPage";
import Lottery from "./components/Lottery";
import Uploadh from "./components/uploadh";
import VideoList from "./components/VideoList";

// import GranRifa from "./components/GranRifa";
import AddParticipant from "./components/AddParticipant";

// import MoniToRifa from "./components/MoniToRifa";
// import Revisionrifa from "./components/Revisionrifa";
// import VmixDisplay from "./components/vmix";
// import VmixDisplay2 from "./components/VmixDisplay2";

import Predicciones2 from "./components/Predicciones2";
import PrediccionesTabla from "./components/PrediccionesTabla";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/coin-history" element={<CoinHistory />} />
        <Route path="/lottery" element={<Lottery />} />

        <Route path="/predicciones" element={<Predicciones2 />} />
        <Route path="/predicciones-tabla" element={<PrediccionesTabla />} />

        <Route path="/maintenance" element={<MaintenancePage />} />
        <Route path="/recommended" element={<RecommendedNumbers />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/WeeklyStatistics" element={<WeeklyStatistics />} />
        <Route path="/EditProfile" element={<EditProfile />} />
        <Route path="/Monitor" element={<Monitor />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/historial-chat" element={<HistorialChat />} />
        <Route path="/ConnectedUsers" element={<ConnectedUsers />} />
        <Route path="/InvestPage" element={<InvestPage />} />
        <Route path="/uploadh" element={<Uploadh />} />
        <Route path="/VideoList" element={<VideoList />} />

        {/* <Route path="/tombola" element={<GranRifa />} /> */}
        <Route path="/AddParticipant" element={<AddParticipant />} />
        {/* <Route path="/MoniToRifa" element={<MoniToRifa />} />
        <Route path="/Revisionrifa" element={<Revisionrifa />} />
        <Route path="/vmix" element={<VmixDisplay />} />
        <Route path="/VmixDisplay2" element={<VmixDisplay2 />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
